import classNames from 'classnames';
import React, { forwardRef, ReactElement } from 'react';

export enum ButtonVariants {
  'light' = 'light',
  'blue' = 'blue',
  'red' = 'red',
  'green' = 'green',
  'default' = 'default',
  'tab' = 'tab',
  'bluefilled' = 'bluefilled',
  'greyfilled' = 'greyfilled',
  'bluebordered' = 'bluebordered',
  'bluetext' = 'bluetext',
  'clear-tech-green' = 'clear-tech-green',
  'pinkfilled' = 'pinkfilled',
}

interface ButtonProps extends React.PropsWithChildren {
  id?: string;
  type?: 'submit' | 'button' | 'reset';
  name?: string;
  rounded?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '';
  className?: string;
  variant?: ButtonVariants;
  startIcon?: ReactElement;
  onClick?: React.EventHandler<React.MouseEvent | React.TouchEvent>;
  disabled?: boolean;
  text?: string;
}

const Button: React.FC<ButtonProps> = forwardRef<
  HTMLButtonElement,
  ButtonProps
>((props, ref) => {
  const classes = classNames({
    button: true,
    [`button-${props.variant}`]: !!props.variant,
    [`rounded-${props.rounded}`]: !!props.rounded,
    [`${props.className}`]: !!props.className,
    ['button-disabled']: props.disabled,
  });
  return (
    <button
      ref={ref}
      className={`${classes}`}
      onClick={props.onClick}
      id={props.id}
      type={props.type}
      name={props.name}
      aria-label={props.text || props.children?.toString()}
      disabled={props.disabled}
    >
      {props.startIcon}
      {props.children}
    </button>
  );
});

Button.defaultProps = {
  rounded: 'sm',
  variant: ButtonVariants.default,
  onClick: () => {
    // do nothing
  },
  disabled: false,
  id: undefined,
  name: undefined,
  type: 'button',
};
Button.displayName = 'Button';
export { Button };
